module.exports = __webpack_public_path__ + "static/media/startIconFabCalc.8288a91a.svg";